import {Button} from '@guestapp/ui';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  margin-top: 24px;
`;
